export const BUZZ_COMPONENT_COPY = 'component-copy';
